import UiHelper from './UiHelper';

class NinjaForms
{
    constructor()
    {
        this.onRender = this.onRender.bind(this);
    }

    init()
    {
        if (typeof Marionette !== 'undefined')
        {
            const nf = this;
            const ninjaFormsController = Marionette.Object.extend({

                initialize: function()
                {
                    this.listenTo( nfRadio.channel( 'form' ), 'render:view', nf.onRender );
                }

            });
            new ninjaFormsController();
        }
    }

    onRender()
    {
        this.singleCheckboxes();
    }

        singleCheckboxes()
        {
            const checkboxContainers = UiHelper.getNodes('.nf-field-container.checkbox-container');
            if (checkboxContainers.length)
            {
                Array.from(checkboxContainers).forEach(checkboxContainer =>
                {
                    const label = checkboxContainer.querySelector('.nf-field-label label');
                    const inputWrap = checkboxContainer.querySelector('.nf-field-element');
                    const input = checkboxContainer.querySelector('.nf-field-element input');
                    inputWrap.insertBefore(label, input.nextSibling);
                });
            }
        }
}

export default NinjaForms;
